import { PageConfig } from './page-config'

export function buildApiHeaders(brand?: string): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    ...(brand ? { 'X-Brand': brand } : {})
  }
}

export interface AkamaiApiHeaders {
  customHeaders?: [string, string][]
}

export function getAkamaiHeaders(): AkamaiApiHeaders {
  return {
    customHeaders: [
      [
        'X-Deep-Application-Id',
        process?.env?.HEADER_X_DEEP_APPLICATION_ID ?? ''
      ]
    ]
  }
}

export function getPreviewHeaders(): [string, string][] | undefined {
  const pageContext = PageConfig?.getConfig() as { isPreview?: boolean } | null
  if (!pageContext?.isPreview) {
    return undefined
  }
  return [['X-View-Type', 'preview']]
}

export function getServerSideHeaders(): AkamaiApiHeaders {
  const previewHeaders = getPreviewHeaders()
  const { customHeaders: akamaiHeaders } = getAkamaiHeaders()
  return {
    customHeaders: [...(previewHeaders ?? []), ...(akamaiHeaders ?? [])]
  }
}
